import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FallbackError } from '@bloomays-lib/ui.shared';
import { styled } from '@mui/material/styles';
import { useQuery } from '@apollo/client';
import {
  GetLegalContractsGQLParams,
  GetLegalContractsGQLResult,
  MissionStatusFilter,
} from '@bloomays-lib/types.shared';
import { GET_LEGAL_CONTRACTS } from '@bloomays-lib/adapter.api-bloomer';
import { LoaderPending } from '@bloomays-lib/ui.shared';
import TableLegalContracts from '../organisms/TableLegalContracts';
import LabelAndSelectField from '../molecules/LabelAndSelectField';
import { PageHeader } from '../molecules/PageHeader';

const Contracts = ({ play = true }: { play?: boolean }) => {
  const { t } = useTranslation(['legalContracts', 'mission']);
  const [status, setStatus] = useState<MissionStatusFilter>(MissionStatusFilter.ACTIVE);

  const {
    loading,
    error,
    data: resultData,
    refetch,
  } = useQuery<GetLegalContractsGQLResult, GetLegalContractsGQLParams>(GET_LEGAL_CONTRACTS, {
    variables: { status },
  });

  return (
    <Container>
      <PageHeader
        id="titleAdminDashboardAllContracts"
        title={t('pageTitle')}
        onRefresh={async () => {
          await refetch();
        }}
      >
        <FilterContainer>
          <LabelAndSelectField
            sx={{ width: '50%' }}
            textLabel={t('statusLabel', { ns: 'mission' })}
            name="status"
            options={[
              { value: MissionStatusFilter.FINISHED, label: t('finished', { ns: 'mission' }) },
              { value: MissionStatusFilter.ACTIVE, label: t('active', { ns: 'mission' }) },
              { value: MissionStatusFilter.INCOMING, label: t('incoming', { ns: 'mission' }) },
            ]}
            value={status}
            defaultOption={false}
            required={true}
            handlechange={(e) => {
              setStatus(e.target.value as MissionStatusFilter);
            }}
          />
        </FilterContainer>
      </PageHeader>
      <TableContainer>
        {loading ? (
          <LoaderPending text={t('fecthingAllContracts')} rotate={play} />
        ) : error ? (
          <FallbackError errorText={t('errorFetchingContracts')}></FallbackError>
        ) : !resultData || resultData.getLegalContracts.length === 0 ? (
          <NoResult>{t('noMission', { ns: 'mission' })}</NoResult>
        ) : (
          <TableLegalContracts missionsContracts={resultData?.getLegalContracts} />
        )}
      </TableContainer>
    </Container>
  );
};

export default Contracts;

const Container = styled('div')(() => ({
  margin: 'auto',
  width: '90%',
}));

const TableContainer = styled('div')(() => ({
  marginTop: '50px',
  display: 'flex',
  justifyContent: 'center',
}));

const NoResult = styled('div')(({ theme }) => ({
  width: '80%',
  backgroundColor: theme.palette.red[60],
  height: '200px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const FilterContainer = styled('div')(() => ({
  minWidth: '220px',
}));
